import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageAPL8 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Première Ligue attendance surge",
            author: "footballgirl",
                date: "Fevrier, 2026",
            image: "images/apl/8a.jpg",
            content: `<h3>Arkema Première Ligue attendance surge</h3>

<p>The Arkema Première Ligue has experienced remarkable growth during the 2025/2026 season, with average attendance reaching <strong>2,086</strong> spectators per match—nearly double the figure from two years earlier. This surge is largely driven by the strategic decision to host more matches in large, premium stadiums, including standout crowds for clubs like Nantes, Lens, and Lyon.</p>

<p>In the first half of the season (phase aller), a total of <strong>137,683</strong> spectators attended matches, marking a <strong>+33%</strong> increase compared to the same period in 2024/2025 (100,963) and an impressive <strong>+81%</strong> rise from 2023/2024. With 66 matches played in the first half, exactly 33 took place in major venues such as Stade de la Beaujoire (Nantes), Stade Bollaert-Delelis (Lens), Groupama Stadium (OL Lyonnes), Stade de la Meinau (Strasbourg), and Stade Océane (Le Havre). Projections indicate nearly 70 such high-capacity games for the full season—almost double the total from two seasons ago.</p>

<p>Record attendances have become frequent highlights:</p>
<ul>
  <li>FC Nantes drew <strong>17,491</strong> fans to Stade de la Beaujoire for their 3-0 win over Marseille on 14 December 2025—the sixth-highest in league history.</li>
  <li>Nantes also attracted <strong>13,454</strong> against Paris FC earlier in the campaign.</li>
  <li>RC Lens welcomed <strong>10,712</strong> for their season opener against PSG at Bollaert-Delelis.</li>
</ul>

<p>Club home averages in the first half reflected this momentum: Nantes led with <strong>5,776</strong> per game, followed by OL Lyonnes (<strong>5,001</strong>) and RC Lens (<strong>4,277</strong>).</p>

<p>The positive trend has continued into the second half. In February 2026, the high-profile PSG vs OL Lyonnes clash at Parc des Princes drew <strong>14,070</strong> spectators—the second-highest crowd of the season so far.</p>

<p>Broadcast figures have mirrored the on-pitch success, with <strong>733,672</strong> television and digital viewers in the first half—a <strong>+79%</strong> year-on-year increase. Average viewership per match stood at around 16,674, with peaks including Lens vs OL (<strong>47,564</strong>) and Saint-Étienne vs OL (<strong>46,811</strong>). Two matches per round are broadcast on Canal+, while the remainder are freely streamed on the league’s YouTube channel.</p>

<p>Thanks to these developments, the Arkema Première Ligue has overtaken Spain’s Liga F in average attendance, establishing itself as one of Europe’s most strongly supported women’s top divisions.</p>

<p>Key factors include affordable family-friendly ticketing (e.g., free child places with adult tickets on select weekends), improved facilities and broadcast quality, and greater club investment in women’s teams. LFFP Managing Director Paul-Hervé Douillard emphasized that playing in bigger stadiums provides better conditions for athletes and enhances viewing experiences. Nantes coach Nicolas Chabot noted the emotional difference of performing in front of thousands rather than dozens, while Lyon defender Selma Bacha expressed confidence that regular sell-outs in major arenas are on the horizon.</p>

<p>With the season well underway as of March 2026 and momentum building, the Arkema Première Ligue is poised for its strongest attendance campaign yet—clear evidence that women’s football in France has evolved into a mainstream, high-draw spectacle.</p>
<h1>阿克玛法国超级联赛（Arkema Première Ligue）观众人数激增</h1>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>

<p>阿克玛法国超级联赛在2025/2026赛季取得了显著增长，平均每场比赛观众人数达到<strong>2,086</strong>人——几乎是两年前的两倍。这一激增主要得益于战略性地将更多比赛安排在大规模、高端体育场进行，包括南特（Nantes）、朗斯（Lens）和里昂（Lyon）等俱乐部吸引了大量观众。</p>

<p>赛季上半程（前半阶段），共有<strong>137,683</strong>名观众到场观赛，比2024/2025赛季同期（100,963人）增长<strong>+33%</strong>，比2023/2024赛季增长<strong>+81%</strong>。上半程共进行66场比赛，其中正好33场在大体育场举行，例如南特的博乔瓦尔球场（Stade de la Beaujoire）、朗斯的博拉尔-德勒利球场（Stade Bollaert-Delelis）、里昂女子队的Groupama体育场（Groupama Stadium）、斯特拉斯堡的梅诺球场（Stade de la Meinau）和勒阿弗尔的海洋球场（Stade Océane）。预计整个赛季将在高端体育场举行近70场比赛——几乎是两年前的两倍。</p>

<p>破纪录的观众人数已成为频繁亮点：</p>
<ul>
  <li>南特足球俱乐部在2025年12月14日以3-0战胜马赛的比赛中，吸引<strong>17,491</strong>名球迷来到博乔瓦尔球场——这是联赛历史上第六高的观众人数。</li>
  <li>南特在本赛季早些时候对阵巴黎FC的比赛中也吸引了<strong>13,454</strong>人。</li>
  <li>朗斯在赛季揭幕战对阵巴黎圣日耳曼的比赛中，在博拉尔-德勒利球场迎来了<strong>10,712</strong>名观众。</li>
</ul>

<p>上半程各俱乐部主场平均观众人数反映了这一势头：南特以每场<strong>5,776</strong>人领先，其次是里昂女子队（<strong>5,001</strong>人）和朗斯（<strong>4,277</strong>人）。</p>

<p>这一积极趋势在下半程继续延续。2026年2月，巴黎圣日耳曼对阵里昂女子队的高级别对决在王子公园球场（Parc des Princes）吸引了<strong>14,070</strong>名观众——这是本赛季迄今为止第二高的观众人数。</p>

<p>转播数据也反映了球场上的成功，上半程电视和数字观众总数达到<strong>733,672</strong>人——同比增长<strong>+79%</strong>。每场比赛平均观众约为16,674人，峰值包括朗斯对里昂（<strong>47,564</strong>人）和圣埃蒂安对里昂（<strong>46,811</strong>人）。每轮有两场比赛在Canal+播出，其余比赛在联赛的YouTube频道免费直播。</p>

<p>得益于这些发展，阿克玛法国超级联赛的平均观众人数已超过西班牙的Liga F，成为欧洲支持度最高的女足顶级联赛之一。</p>

<p>关键因素包括实惠的家庭友好票价（例如选定周末成人票免费带儿童）、改善的设施和转播质量，以及俱乐部对女足球队的更大投入。LFFP总经理保罗-埃尔韦·杜亚拉尔（Paul-Hervé Douillard）强调，在更大体育场比赛为运动员提供更好的条件，并显著提升观赛体验。南特主帅尼古拉斯·沙博（Nicolas Chabot）指出，在成千上万观众面前表演与只有几十人时的情感差异巨大，而里昂后卫塞尔玛·巴查（Selma Bacha）表示相信定期售罄大型竞技场指日可待。</p>

<p>截至2026年3月，赛季正如火如荼进行，势头持续增强，阿克玛法国超级联赛有望迎来其历史上最成功的观众赛季——这清楚地证明法国女足已从小众吸引力转变为主流、高吸引力的景观。</p>`,
  tags: ["france", "attendance", "ticketing", "Arkema Première Ligue"],
            readingTime: "6 min read",  
                      
navIndices: { prev: 'apl-7', next: 'apl-9' }
        });
    }

    init() {
        console.log('ArticlePageAPL8 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to APL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'apl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_apl.png';
            leagueLogo.alt = 'APL';
        }
    }
}